import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsApp = () => {
  return (
    <a
      href={`https://wa.link/5wtrfy`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600 transition duration-300"
      style={{ zIndex: 1000 }}
    >
      <FaWhatsapp size={24} />
    </a>
  );
};

export default FloatingWhatsApp;
